import React, { lazy, useState, useEffect } from 'react';
import type { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../components/auth/ProtectedRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ActivitiesPage = lazy(() => import('../pages/activities/page'));
const LegalInfoPage = lazy(() => import('../pages/legal-info/page'));
const LegalDetailPage = lazy(() => import('../pages/legal-detail/page'));
const AnnouncementsPage = lazy(() => import('../pages/announcements/page'));
const AnnouncementDetailPage = lazy(() => import('../pages/announcement-detail/page'));
const EventDetailPage = lazy(() => import('../pages/event-detail/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NewYearParty = lazy(() => import('../pages/NewYearParty'));
const LoginPage = lazy(() => import('../pages/login/page'));
const PanelPage = lazy(() => import('../pages/panel/page'));
const ComingSoonPage = lazy(() => import('../pages/muvekkil-takip/page'));

const QRCreatorPage = lazy(() => import('../pages/qr-creator/page'));
const QRRedirectPage = lazy(() => import('../pages/qr-redirect/page'));
const ExecutionCalculatorPage = lazy(
  () => import('../pages/execution-calculator/page')
);
const ResetPasswordPage = lazy(() => import('../pages/reset-password/page'));

const NotFound404Legal = lazy(() => import('../pages/NotFound404Legal'));
const NotFound404Funny = lazy(() => import('../pages/NotFound404Funny'));
const NotFound404Creative = lazy(() => import('../pages/NotFound404Creative'));
const NotFound404Professional = lazy(() => import('../pages/NotFound404Professional'));

const RandomNotFoundWrapper = () => {
  const [SelectedPage, setSelectedPage] =
    useState<React.LazyExoticComponent<any> | null>(null);

  useEffect(() => {
    const pages = [
      NotFound404Legal,
      NotFound404Funny,
      NotFound404Creative,
      NotFound404Professional,
    ];
    const randomIndex = Math.floor(Math.random() * pages.length);
    setSelectedPage(pages[randomIndex]);
  }, []);

  if (!SelectedPage) return null;
  return <SelectedPage />;
};

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/panel',
    element: (
      <ProtectedRoute requireAdminPanel>
        <PanelPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/hakkimizda',
    element: <AboutPage />,
  },
  {
    path: '/muvekkil-takip',
    element: (
      <ProtectedRoute requireClientTrackingAccess>
        <ComingSoonPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/faaliyetlerimiz',
    element: <ActivitiesPage />,
  },
  {
    path: '/hukuki-bilgiler',
    element: <LegalInfoPage />,
  },
  {
    path: '/hukuki-bilgiler/:slug',
    element: <LegalDetailPage />,
  },
  {
    path: '/duyurular',
    element: <AnnouncementsPage />,
  },
  {
    path: '/duyuru/:slug',
    element: <AnnouncementDetailPage />,
  },
  {
    path: '/iletisim',
    element: <ContactPage />,
  },
  {
    path: '/etkinlik/:slug',
    element: <EventDetailPage />,
  },
  {
    path: '/party',
    element: <NewYearParty />,
  },
  {
    path: '/QRcodecreator',
    element: (
      <ProtectedRoute requireQrAccess>
        <QRCreatorPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/QRcodecreater',
    element: (
      <ProtectedRoute requireQrAccess>
        <QRCreatorPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/q/:id',
    element: <QRRedirectPage />,
  },
  {
    path: '/infazcalculator',
    element: (
      <ProtectedRoute requireInfazAccess>
        <ExecutionCalculatorPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/sifre-sifirla',
    element: <ResetPasswordPage />,
  },
  {
    path: '*',
    element: <RandomNotFoundWrapper />,
  },
];

export default routes;